import { Divider, Image } from "antd";
// import vnpayMethod from "../../../assets/payment-method/vnpay.png";
import paypalMethod from "../../../assets/payment-method/paypal-method.png";
import { useTranslation } from "react-i18next";

const PaymentProcessing = () => {
  const { t } = useTranslation();

  return (
    <div className="max-w-[1290px] mx-auto py-4">
      <div className="grid grid-cols-1 gap-5 w-full">
        <div className="w-full bg-[#8BBDEA]/20 px-8 py-2 justify-center rounded-xl">
          <div className="text-[#074799] text-left font-bold text-base">
            {t("select_payment_option.description")}
          </div>
        </div>

        <div className="w-full grid md:grid-cols-2 grid-cols-1 gap-8 text-[#074799]">
          {/* Left Side */}
          <div className="flex flex-col gap-5">
            {/* Card Info Section */}
            <div className="flex flex-col justify-center items-center border rounded-xl px-6 py-2">
              <div className="w-full flex justify-between items-center">
                <div className="flex gap-2 text-base">Paypal</div>

                <div className="flex gap-4">
                  <Image
                    src={paypalMethod}
                    alt="paypal"
                    preview={false}
                    height={40}
                  />
                </div>
              </div>
              {/* <div className="w-full flex justify-between items-center">
                <div className="flex gap-2 text-base">VNPAY</div>

                <div className="flex gap-4">
                  <Image
                    src={vnpayMethod}
                    alt="mastercard"
                    preview={false}
                    height={40}
                  />
                </div>
              </div> */}

              {/* <Divider /> */}

              {/* Card Info */}
              <div className="w-full grid grid-cols-4 gap-6">
                {/* Card Number */}
                {/* <div className="col-span-4 flex flex-col">
                  <Typography.Title
                    style={{
                      fontSize: "16px",
                      fontFamily: "Plus Jakarta Sans, serif",
                      color: "#074799",
                      fontWeight: "400",
                    }}
                  >
                    {t("select_payment_option.card_number")}{" "}
                    <span className="text-[#FF8383]">*</span>
                  </Typography.Title>
                  <Input
                    placeholder="0000 0000 0000 0000"
                    className="border-[#074799]"
                    style={{
                      fontSize: "16px",
                      fontFamily: "Plus Jakarta Sans, serif",
                    }}
                  />
                </div> */}

                {/* Card Name */}
                {/* <div className="col-span-2 flex flex-col">
                  <Typography.Title
                    style={{
                      fontSize: "16px",
                      fontFamily: "Plus Jakarta Sans, serif",
                      color: "#074799",
                      fontWeight: "400",
                    }}
                  >
                    {t("select_payment_option.card_name")}{" "}
                    <span className="text-[#FF8383]">*</span>
                  </Typography.Title>
                  <Input
                    placeholder={t("select_payment_option.card_name")}
                    className="border-[#074799]"
                    style={{
                      fontSize: "16px",
                      fontFamily: "Plus Jakarta Sans, serif",
                    }}
                  />
                </div> */}

                {/* Expire Date */}
                {/* <div className="col-span-1 flex flex-col">
                  <Typography.Title
                    style={{
                      fontSize: "16px",
                      fontFamily: "Plus Jakarta Sans, serif",
                      color: "#074799",
                      fontWeight: "400",
                    }}
                  >
                    {t("select_payment_option.expiry_date")}{" "}
                    <span className="text-[#FF8383]">*</span>
                  </Typography.Title>
                  <Input
                    placeholder="MM/YY"
                    className="border-[#074799]"
                    style={{
                      fontSize: "16px",
                      fontFamily: "Plus Jakarta Sans, serif",
                    }}
                  />
                </div> */}

                {/* CVV */}
                {/* <div className="col-span-1 flex flex-col">
                  <Typography.Title
                    style={{
                      fontSize: "16px",
                      fontFamily: "Plus Jakarta Sans, serif",
                      color: "#074799",
                      fontWeight: "400",
                    }}
                  >
                    CVV <span className="text-[#FF8383]">*</span>
                  </Typography.Title>
                  <Input
                    placeholder="CVV"
                    className="border-[#074799]"
                    style={{
                      fontSize: "16px",
                      fontFamily: "Plus Jakarta Sans, serif",
                    }}
                  />
                </div> */}
              </div>
            </div>
          </div>

          {/* Right Side */}
          <div className="flex flex-col gap-4 justify-between">
            <div className="flex flex-col justify-center items-center border rounded-xl px-6 py-2 text-base">
              <p className="font-bold">
                {t("select_payment_option.order_summary")}
              </p>

              <Divider />

              <div className="w-full grid grid-cols-3 text-black gap-4">
                <p className="col-span-1">{t("payment_details.visa_fee")}</p>
                <p className="col-span-1">
                  {t("select_payment_option.order_summary.quantity")}: 1
                </p>
                <p className="col-span-1 text-right text-[#074799] font-bold">
                  39.50 $
                </p>

                <p className="col-span-1">
                  {t("select_payment_option.order_summary.processing_fee")}
                </p>
                <p className="col-span-2 text-right text-[#074799] font-bold">
                  20 $
                </p>

                <p className="col-span-1">
                  {t("select_payment_option.order_summary.tax")}
                </p>
                <p className="col-span-2 text-right text-[#074799] font-bold">
                  3.95 $
                </p>
              </div>
            </div>

            <div className="flex justify-between items-center border rounded-xl px-6 py-4">
              <p className="font-bold text-base">
                {t("select_payment_option.order_summary.total")}
              </p>

              <p className="font-bold text-xl">63.45 $</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentProcessing;
